/**
 *
 * @author Matthew Rawson @ 14/08/2018 15:00
 * @description
 * @notes
 */
import React from "react"
import PropTypes from "prop-types"
import Sticky from "react-sticky-el"
import styled from "styled-components"
import {Grid} from "react-bootstrap"

import id from "@irati/utils/id"
import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"

import sitemap from "../../routes/sitemap"


/** n.b. 167px is made up of header height + sticky page footer height */
const PageContent = styled(Grid)`
  position: relative;
  min-height: calc(100vh - 167px);
  padding-top: ${padding.tiny};
  margin-bottom: ${padding.base};
`

export const StickyPageFooter = styled(Sticky)`
  background-color: ${greys.white};
  box-shadow: 0 -2px 2px 0 rgba(100, 100, 100, 0.1);
  &:after {
    content: "";
    width: 100%;
    height: 1px;
    box-shadow: 0 1px 0 0 rgba(100, 100, 100, 0.1);
    display: block;
  }
`

const Footer = styled(Grid)`
  height: 82px;
  overflow: hidden;
`


const PageWithStickyFooter = ({children, footerChildren, match, className, ...props}) => {
  const idNamespace = id("PageWithStickyFooter", props)

  return (
    <div {...props} id={idNamespace}>
      <PageContent>
        {children}
      </PageContent>
      <StickyPageFooter mode="bottom" className={className}>
        <Footer>
          {footerChildren}
        </Footer>
      </StickyPageFooter>
    </div>
  )
}


PageWithStickyFooter.propTypes = {
  children: PropTypes.any.isRequired,
  footerChildren: PropTypes.any.isRequired
}
PageWithStickyFooter.defaultProps = {
  crumbs: [sitemap.homepage, sitemap.scheduleAdd]
}

export default PageWithStickyFooter
